export default {
  "hero.tag": "OOPBUY Spreadsheet Official",
  "hero.title": "OOPBUY Spreadsheet · Dein Gateway zu Premium Fashion",
  "hero.subtitle": "Entdecke die besten Kategorien, Guides und Trusted Sellers für dein nächstes Shopping-Erlebnis.",
  "hero.dropdown.placeholder": "Kategorie wählen",
  "hero.cta.primary": "OOPBUY Spreadsheet",
  "hero.cta.secondary": "Buy it now",
  "categories.title": "Beliebte Kategorien",
  "categories.subtitle": "Durchstöbere unsere sorgfältig kuratierten Produktkategorien und finde genau das, was du suchst.",
  "categories.explore": "Mehr erfahren",
  "cta.title": "Mach den nächsten Schritt mit OOPBUY Spreadsheet",
  "cta.subtitle": "Entdecke tausende Premium-Produkte auf kaspreadsheet.com mit den besten Bewertungen und sichersten Verkäufern.",
  "cta.button": "Jetzt bei kaspreadsheet.com shoppen",
  "seo.title": "OOPBUY Spreadsheet Guides & News",
  "seo.subtitle": "Unsere unabhängigen SEO-Ressourcen und Original-Guides helfen dir, das Beste aus OOPBUY Spreadsheet herauszuholen. Alle Inhalte werden regelmäßig aktualisiert und von Experten geprüft.",
  "seo.guide.title": "Was ist OOPBUY Spreadsheet?",
  "seo.guide.excerpt": "Der ultimative Guide für Einsteiger und Profis. Erfahre alles über OOPBUY Spreadsheet, die besten Kategorien und wie du sicher einkaufst.",
  "seo.guide.readMore": "Zum vollständigen Guide",
  "seo.experience.title": "OOPBUY Spreadsheet Erfahrungen",
  "seo.experience.excerpt": "Echte Erfahrungsberichte von deutschen Nutzern. Lies, was die Community über OOPBUY Spreadsheet sagt.",
  "seo.germany.title": "OOPBUY Spreadsheet Germany Guide",
  "seo.germany.excerpt": "Speziell für den deutschen Markt: Versand, Zoll und die besten Tipps für OOPBUY Spreadsheet in Deutschland.",
  "seo.badge.new": "NEU",
  "about.tag": "Warum wir?",
  "about.title": "OOPBUY Spreadsheet bietet dir Trusted Sellers, QC und Shipping-Infos.",
  "about.subtitle": "Wir sind eine unabhängige Informationsplattform, die deutschen Nutzern hilft, sicher und informiert über OOPBUY Spreadsheet einzukaufen. Keine versteckten Gebühren, keine Fake-Bewertungen – nur ehrliche, geprüfte Informationen.",
  "about.stat1": "14+",
  "about.stat1Label": "Kategorien",
  "about.stat2": "100%",
  "about.stat2Label": "Unabhängig",
  "about.stat3": "DE",
  "about.stat3Label": "Deutschland Fokus",
  "testimonial.tag": "Kundenstimmen",
  "testimonial.quote": "OOPBUY Spreadsheet hat mein Shopping komplett verändert. Die Guides sind unglaublich detailliert und die Kategorie-Übersicht spart mir Stunden an Recherche.",
  "testimonial.name": "Alexander K.",
  "testimonial.location": "Berlin, Deutschland",
  "testimonial.verified": "Verifizierte Bewertung",
  "footer.brand": "OOPBUY Spreadsheet",
  "footer.description": "Deine unabhängige Informationsquelle für OOPBUY Spreadsheet in Deutschland. Wir bieten Guides, Kategorien und Trusted Seller Informationen.",
  "footer.categories": "Kategorien",
  "footer.guides": "Top Guides",
  "footer.legal": "Rechtliches",
  "footer.legal.disclaimer": "Haftungsausschluss",
  "footer.legal.privacy": "Datenschutz",
  "footer.legal.terms": "Nutzungsbedingungen",
  "footer.legal.safety": "Sicherheit",
  "footer.copyright": "© OOPBUY Spreadsheet 2026",
  "footer.rights": "Alle Rechte vorbehalten.",
  "footer.tagline": "Qualität. Transparenz. Community.",
  "footer.newsletter.title": "Bleib auf dem Laufenden",
  "footer.newsletter.placeholder": "Deine E-Mail-Adresse",
  "footer.newsletter.button": "Abonnieren",
  "article.backToHome": "← Zurück zur Startseite",
  "article.readingTime": "Lesezeit",
  "article.minutes": "Minuten",
  "article.updated": "Aktualisiert am",
  "article.toc": "Inhaltsverzeichnis",
  "article.related": "Ähnliche Artikel",
  "article.cta": "Jetzt auf kaspreadsheet.com entdecken",
  "nav.home": "Startseite",
  "nav.guide": "Guide",
  "nav.categories": "Kategorien",
};